import { useState, useEffect, useCallback } from "react";
import api from "../api";
import { useTheme } from "../components/Theme";

const ORANGE = "#EE6A1A";
const VERDE = "#1D9E75";

const fmtMoeda = (v) => "R$ " + Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtData = (d) => {
  if (!d) return "—";
  const s = String(d).slice(0, 10).split("-");
  return s.length === 3 ? s[2] + "/" + s[1] + "/" + s[0] : "—";
};
const hoje = () => new Date().toISOString().slice(0, 10);

function ModalPacote({ pacote, onFechar, onSalvar }) {
  const isNew = !pacote || !pacote._id;
  const [f, setF] = useState({
    pacienteNome: pacote?.pacienteNome || "",
    telefone: pacote?.telefone || "",
    procedimento: pacote?.procedimento || "",
    totalSessoes: pacote?.totalSessoes || 10,
    valorTotal: pacote?.valorTotal || "",
    dataVenda: (pacote?.dataVenda || "").slice(0, 10) || hoje(),
    validade: (pacote?.validade || "").slice(0, 10) || "",
    obs: pacote?.obs || "",
  });
  const [erro, setErro] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [catalogo, setCatalogo] = useState([]);
  useEffect(() => { api.get("/catalogo").then(({ data }) => setCatalogo(Array.isArray(data) ? data : [])).catch(() => {}); }, []);
  const escolherProcedimento = (v) => setF((x) => {
    const it = catalogo.find((c) => c.nome === v);
    const sess = it && it.sessoesPadrao ? it.sessoesPadrao : Number(x.totalSessoes) || 0;
    return { ...x, procedimento: v,
      totalSessoes: it && it.sessoesPadrao ? it.sessoesPadrao : x.totalSessoes,
      valorTotal: it && it.preco ? Math.round(it.preco * (sess || 1) * 100) / 100 : x.valorTotal };
  });
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));

  const inp = { width: "100%", boxSizing: "border-box", padding: "9px 11px", borderRadius: 8, border: "1px solid var(--border-color)", background: "var(--input-bg)", color: "var(--text-primary)", fontSize: 13, fontFamily: "'Inter',sans-serif", outline: "none" };
  const lbl = { fontSize: 11, fontWeight: 600, color: "var(--text-secondary)", marginBottom: 5, display: "block", textTransform: "uppercase", letterSpacing: ".04em" };

  const salvar = async () => {
    if (!f.pacienteNome.trim()) return setErro("Informe o nome do paciente.");
    if (!f.procedimento.trim()) return setErro("Informe o procedimento.");
    setErro(""); setSalvando(true);
    try {
      const corpo = { ...f, totalSessoes: Number(f.totalSessoes) || 1, valorTotal: Number(f.valorTotal) || 0, validade: f.validade || null };
      const { data } = isNew ? await api.post("/pacotes", corpo) : await api.put(`/pacotes/${pacote._id}`, corpo);
      onSalvar(data);
    } catch (err) {
      setErro((err.response && err.response.data && err.response.data.message) || "Não foi possível salvar.");
    } finally { setSalvando(false); }
  };

  return (
    <div onClick={onFechar} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.45)", zIndex: 1000, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "40px 16px", overflowY: "auto" }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "var(--card-bg)", borderRadius: 14, padding: 24, width: "100%", maxWidth: 520, boxShadow: "0 20px 60px rgba(0,0,0,.25)" }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: "var(--text-primary)", marginBottom: 18 }}>{isNew ? "Novo pacote" : "Editar pacote"}</div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 160px", gap: 12, marginBottom: 14 }}>
          <div><label style={lbl}>Paciente</label><input autoFocus value={f.pacienteNome} onChange={(e) => set("pacienteNome", e.target.value)} placeholder="Nome de quem comprou" style={inp} /></div>
          <div><label style={lbl}>Telefone</label><input value={f.telefone} onChange={(e) => set("telefone", e.target.value)} placeholder="(00) 00000-0000" style={inp} /></div>
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={lbl}>Procedimento</label>
          <input list="lista-procedimentos-pac" value={f.procedimento} onChange={(e) => escolherProcedimento(e.target.value)} placeholder="Ex: Limpeza de pele" style={inp} />
          <datalist id="lista-procedimentos-pac">{catalogo.map((c) => <option key={c._id} value={c.nome} />)}</datalist>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
          <div><label style={lbl}>Sessões vendidas</label><input type="number" min={1} max={200} value={f.totalSessoes} onChange={(e) => set("totalSessoes", e.target.value)} style={inp} /></div>
          <div><label style={lbl}>Valor total</label><input type="number" step="0.01" value={f.valorTotal} onChange={(e) => set("valorTotal", e.target.value)} placeholder="0,00" style={inp} /></div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
          <div><label style={lbl}>Data da venda</label><input type="date" value={f.dataVenda} onChange={(e) => set("dataVenda", e.target.value)} style={inp} /></div>
          <div><label style={lbl}>Validade (opcional)</label><input type="date" value={f.validade} onChange={(e) => set("validade", e.target.value)} style={inp} /></div>
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={lbl}>Observações</label>
          <textarea rows={2} value={f.obs} onChange={(e) => set("obs", e.target.value)} style={{ ...inp, resize: "vertical" }} />
        </div>

        {erro && <div style={{ fontSize: 13, color: "#ef4444", marginBottom: 12 }}>{erro}</div>}

        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button onClick={onFechar} style={{ padding: "10px 18px", borderRadius: 9, border: "1px solid var(--border-color)", background: "transparent", color: "var(--text-secondary)", fontWeight: 600, fontSize: 13, cursor: "pointer" }}>Cancelar</button>
          <button onClick={salvar} disabled={salvando} style={{ padding: "10px 20px", borderRadius: 9, border: 0, background: ORANGE, color: "#fff", fontWeight: 700, fontSize: 13, cursor: "pointer", opacity: salvando ? .6 : 1 }}>{salvando ? "Salvando..." : "Salvar"}</button>
        </div>
      </div>
    </div>
  );
}

function ModalHistorico({ pacote, onFechar, onMudou }) {
  const [p, setP] = useState(pacote);
  const desfazer = async (sid) => {
    if (!window.confirm("Desfazer esta sessão? Ela volta para o saldo do pacote.")) return;
    try {
      const { data } = await api.delete(`/pacotes/${p._id}/sessoes/${sid}`);
      setP(data); onMudou(data);
    } catch (err) { window.alert((err.response && err.response.data && err.response.data.message) || "Não foi possível desfazer."); }
  };
  const sessoes = [...(p.sessoes || [])].reverse();
  return (
    <div onClick={onFechar} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.45)", zIndex: 1000, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "40px 16px", overflowY: "auto" }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "var(--card-bg)", borderRadius: 14, padding: 24, width: "100%", maxWidth: 480, boxShadow: "0 20px 60px rgba(0,0,0,.25)" }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: "var(--text-primary)" }}>{p.pacienteNome}</div>
        <div style={{ fontSize: 13, color: "var(--text-secondary)", marginBottom: 16 }}>{p.procedimento} · {p.realizadas} de {p.totalSessoes} sessões</div>
        {!sessoes.length && <div style={{ fontSize: 13, color: "var(--text-muted)", padding: "14px 0" }}>Nenhuma sessão realizada ainda.</div>}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {sessoes.map((s, i) => (
            <div key={s._id || i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 9, background: "var(--hover-bg)" }}>
              <span style={{ fontSize: 12, fontWeight: 700, color: VERDE, minWidth: 28 }}>{sessoes.length - i}ª</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, color: "var(--text-primary)" }}>{fmtData(s.data)}</div>
                {s.profissionalNome && <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>{s.profissionalNome}</div>}
                {s.obs && <div style={{ fontSize: 11, color: "var(--text-muted)" }}>{s.obs}</div>}
              </div>
              <button onClick={() => desfazer(s._id)} style={{ background: "none", border: "1px solid var(--border-color)", borderRadius: 7, color: "#ef4444", fontSize: 11, fontWeight: 600, padding: "5px 9px", cursor: "pointer" }}>Desfazer</button>
            </div>
          ))}
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 18 }}>
          <button onClick={onFechar} style={{ padding: "10px 18px", borderRadius: 9, border: "1px solid var(--border-color)", background: "transparent", color: "var(--text-secondary)", fontWeight: 600, fontSize: 13, cursor: "pointer" }}>Fechar</button>
        </div>
      </div>
    </div>
  );
}

export default function Pacotes({ currentUser }) {
  const { theme } = useTheme();
  const [lista, setLista] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [busca, setBusca] = useState("");
  const [verConcluidos, setVerConcluidos] = useState(false);
  const [modal, setModal] = useState(null);
  const [historico, setHistorico] = useState(null);

  const carregar = useCallback(async () => {
    setCarregando(true);
    try {
      const { data } = await api.get("/pacotes", { params: { q: busca || undefined, concluidos: verConcluidos ? 1 : undefined } });
      setLista(data.pacotes || []);
    } catch (e) { setLista([]); }
    setCarregando(false);
  }, [busca, verConcluidos]);

  useEffect(() => { const id = setTimeout(carregar, 250); return () => clearTimeout(id); }, [carregar]);

  const darBaixa = async (p) => {
    if (!window.confirm(`Registrar mais uma sessão de ${p.procedimento} para ${p.pacienteNome}?`)) return;
    try {
      const { data } = await api.post(`/pacotes/${p._id}/sessoes`, { profissionalNome: (currentUser && currentUser.nome) || "" });
      setLista((l) => l.map((x) => (x._id === data._id ? data : x)));
    } catch (err) { window.alert((err.response && err.response.data && err.response.data.message) || "Não foi possível registrar."); }
  };

  const excluir = async (p) => {
    if (!window.confirm(`Excluir o pacote de ${p.pacienteNome}? Isso apaga também o histórico de sessões.`)) return;
    try { await api.delete(`/pacotes/${p._id}`); setLista((l) => l.filter((x) => x._id !== p._id)); }
    catch (e) { window.alert("Não foi possível excluir."); }
  };

  const aposSalvar = (p) => { setModal(null); carregar(); };

  const totais = lista.reduce((a, p) => ({ vendidas: a.vendidas + (p.totalSessoes || 0), feitas: a.feitas + (p.realizadas || 0), valor: a.valor + (p.valorTotal || 0) }), { vendidas: 0, feitas: 0, valor: 0 });

  const th = { textAlign: "left", fontSize: 11, fontWeight: 700, color: "var(--text-secondary)", textTransform: "uppercase", letterSpacing: ".05em", padding: "0 12px 10px" };
  const td = { fontSize: 13, color: "var(--text-primary)", padding: "12px", borderTop: "1px solid var(--border-light)" };
  const botao = (cor) => ({ background: "transparent", border: `1px solid ${cor}55`, color: cor, borderRadius: 7, fontSize: 11.5, fontWeight: 600, padding: "5px 10px", cursor: "pointer", whiteSpace: "nowrap" });

  return (
    <div style={{ padding: 24, fontFamily: "'Inter',-apple-system,sans-serif", background: "var(--page-bg)", minHeight: "100vh" }}>
      <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", gap: 16, flexWrap: "wrap", marginBottom: 20 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: "var(--text-primary)" }}>Pacotes de sessões</h1>
          <p style={{ margin: "4px 0 0", fontSize: 13, color: "var(--text-muted)" }}>Quantas sessões cada paciente comprou e quantas ainda faltam.</p>
        </div>
        <button onClick={() => setModal({})} style={{ padding: "10px 18px", borderRadius: 9, border: 0, background: ORANGE, color: "#fff", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>+ Novo pacote</button>
      </div>

      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
        {[["Pacotes na lista", lista.length], ["Sessões vendidas", totais.vendidas], ["Sessões realizadas", totais.feitas], ["Valor dos pacotes", fmtMoeda(totais.valor)]].map(([rotulo, valor]) => (
          <div key={rotulo} style={{ background: "var(--card-bg)", border: "1px solid var(--border-color)", borderRadius: 11, padding: "12px 16px", minWidth: 150 }}>
            <div style={{ fontSize: 19, fontWeight: 800, color: "var(--text-primary)" }}>{valor}</div>
            <div style={{ fontSize: 11, color: "var(--text-secondary)", textTransform: "uppercase", letterSpacing: ".04em" }}>{rotulo}</div>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", marginBottom: 14 }}>
        <input value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="Buscar paciente ou procedimento" style={{ flex: "1 1 260px", padding: "9px 12px", borderRadius: 9, border: "1px solid var(--border-color)", background: "var(--input-bg)", color: "var(--text-primary)", fontSize: 13, outline: "none", fontFamily: "inherit" }} />
        <label style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 13, color: "var(--text-secondary)", cursor: "pointer" }}>
          <input type="checkbox" checked={verConcluidos} onChange={(e) => setVerConcluidos(e.target.checked)} /> Mostrar concluídos
        </label>
      </div>

      <div style={{ background: "var(--card-bg)", border: "1px solid var(--border-color)", borderRadius: 12, padding: "14px 6px 6px", overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 760 }}>
          <thead>
            <tr>
              <th style={th}>Venda</th><th style={th}>Paciente</th><th style={th}>Procedimento</th>
              <th style={{ ...th, textAlign: "center" }}>Sessões</th>
              <th style={{ ...th, textAlign: "center" }}>Feitas</th>
              <th style={{ ...th, textAlign: "center" }}>Restam</th>
              <th style={{ ...th, textAlign: "right" }}>Valor</th>
              <th style={{ ...th, textAlign: "right" }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {lista.map((p) => {
              const zerado = (p.restam || 0) <= 0;
              return (
                <tr key={p._id}>
                  <td style={{ ...td, color: "var(--text-secondary)", whiteSpace: "nowrap" }}>{fmtData(p.dataVenda)}</td>
                  <td style={{ ...td, fontWeight: 600 }}>
                    {p.pacienteNome}
                    {p.telefone && <div style={{ fontSize: 11, color: "var(--text-muted)", fontWeight: 400 }}>{p.telefone}</div>}
                  </td>
                  <td style={td}>{p.procedimento}</td>
                  <td style={{ ...td, textAlign: "center" }}>{p.totalSessoes}</td>
                  <td style={{ ...td, textAlign: "center" }}>
                    <button onClick={() => setHistorico(p)} style={{ background: "none", border: 0, color: "var(--text-primary)", fontSize: 13, cursor: "pointer", textDecoration: "underline", fontFamily: "inherit" }}>{p.realizadas}</button>
                  </td>
                  <td style={{ ...td, textAlign: "center" }}>
                    <span style={{ fontWeight: 800, fontSize: 13, color: zerado ? "var(--text-muted)" : VERDE, background: zerado ? "var(--hover-bg)" : VERDE + "18", borderRadius: 20, padding: "3px 11px" }}>{zerado ? "concluído" : p.restam}</span>
                  </td>
                  <td style={{ ...td, textAlign: "right", whiteSpace: "nowrap" }}>{fmtMoeda(p.valorTotal)}</td>
                  <td style={{ ...td, textAlign: "right" }}>
                    <div style={{ display: "flex", gap: 6, justifyContent: "flex-end", flexWrap: "wrap" }}>
                      {!zerado && <button onClick={() => darBaixa(p)} style={botao(VERDE)}>Dar baixa</button>}
                      <button onClick={() => setModal(p)} style={botao("var(--text-secondary)")}>Editar</button>
                      <button onClick={() => excluir(p)} style={botao("#ef4444")}>Excluir</button>
                    </div>
                  </td>
                </tr>
              );
            })}
            {!lista.length && !carregando && (
              <tr><td colSpan={8} style={{ ...td, textAlign: "center", color: "var(--text-muted)", padding: "30px 12px" }}>
                {busca ? "Nenhum pacote encontrado." : "Nenhum pacote cadastrado. Clique em “+ Novo pacote” para começar."}
              </td></tr>
            )}
            {carregando && <tr><td colSpan={8} style={{ ...td, textAlign: "center", color: "var(--text-muted)" }}>Carregando…</td></tr>}
          </tbody>
        </table>
      </div>

      {modal && <ModalPacote pacote={modal} onFechar={() => setModal(null)} onSalvar={aposSalvar} />}
      {historico && <ModalHistorico pacote={historico} onFechar={() => setHistorico(null)} onMudou={(p) => setLista((l) => l.map((x) => (x._id === p._id ? p : x)))} />}
      {theme ? null : null}
    </div>
  );
}
